<div class="validate-payroll-code-component-container page-root-container">
  <ng-container *ngIf="!showProceedComponent">
    <div class="page-header">
      <div class="page-title">
        <img class="icon" src="assets/images/menu/svg/attendence-export.svg">
        <span class="title">Attendance Export</span>
      </div>
    </div>

    <div class="data-container">
      <form [formGroup]="filterForm" style="display: flex; gap: 0.5rem; margin-bottom: 1rem; align-items: center;">
        <mat-form-field appearance="fill" class="filter-dropdown">
          <mat-label>Payroll Group</mat-label>
          <input type="text" matInput [matAutocomplete]="payrollGroupAuto"
            [value]="getPayrollGroupDisplay(filterForm.value.payroll_group_id)"
            (input)="filterPayrollGroups(payrollGroupNameInput.value)" #payrollGroupNameInput>
          <button *ngIf="filterForm.value.payroll_group_id" matSuffix mat-icon-button aria-label="Clear"
            (click)="clearPayrollGroup()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #payrollGroupAuto="matAutocomplete"
            (optionSelected)="selectPayrollGroup($event.option.value)">
            <mat-option *ngFor="let group of filteredPayrollGroups" [value]="group">
              <span class="paren">(</span>{{ group.code }}<span class="paren">)</span> <span class="group-name">{{
                group.name }}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field style="min-width:105px;">
          <mat-label>Year</mat-label>
          <mat-select formControlName="year" (selectionChange)="onYearChange()">
            <mat-option *ngFor="let yearObj of yearsList" [value]="yearObj.value">
              {{ yearObj.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="min-width:320px;">
          <mat-label>Week No</mat-label>
          <mat-select formControlName="week_no" panelClass="week-dropdown-panel">
            <mat-option *ngFor="let week of weeks" [value]="week.week_no">
              {{ week.displayText }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button mat-raised-button color="primary" style="height: 56px;" (click)="onValidateClick()" type="button">
          Validate Staff & Attendance
        </button>
      </form>

      <app-loader [show]="isLoading"></app-loader>

      <div *ngIf="showDummy && dummyEmployeeGroups.length > 0" class="employee-group-list">
        <div *ngFor="let group of dummyEmployeeGroups" class="employee-group">
          <div class="group-title"><b>{{ group.groupName }}</b></div>
          <div *ngFor="let emp of group.employees; let i = index" class="employee-row">
            <span class="emp-index">{{ i + 1 }}</span>
            <span class="emp-name">{{ emp.f_name }} {{ emp.l_name }}</span>
            <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu">
              <mat-icon>more_vert</mat-icon>
            </a>
            <mat-menu #rowMenu>
              <button mat-menu-item (click)="onEdit(emp, filterForm.value)">Edit</button>
            </mat-menu>
          </div>
        </div>
      </div>

      <div *ngIf="showDummy && dummyEmployeeGroups.length === 0 && showPayrollProceed && !isLoading"
        class="no-data-container" style="flex-direction: row; gap: 0.5rem;">
        <span class="no-data-info">All active employees have Payroll code.</span>
        <button mat-flat-button color="primary" (click)="onProceed()">Proceed</button>
      </div>

      <div *ngIf="showDummy && dummyEmployeeGroups.length === 0 && !showPayrollProceed && !isLoading"
        class="no-data-container">
        <img src="assets/images/no-data.png">
        <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
      </div>
    </div>
  </ng-container>
</div>